// JavaScript para el Size Chart Modal
document.addEventListener('DOMContentLoaded', function() {
  const sizeChartTrigger = document.getElementById('sizeChartTrigger');
  const sizeChartModal = document.getElementById('sizeChartModal');
  const modalClose = document.getElementById('modalClose');
  
  // Verificar que los elementos existen
  if (!sizeChartTrigger || !sizeChartModal) {
    return;
  }
  
  // Abrir modal al hacer click en el link
  sizeChartTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    sizeChartModal.style.display = 'flex';
    document.body.style.overflow = 'hidden'; // Prevenir scroll del body
    
    // Pequeña animación de entrada
    setTimeout(() => {
      const modalContent = sizeChartModal.querySelector('.modal-content');
      if (modalContent) {
        modalContent.style.transform = 'scale(1)';
      }
    }, 10);
  });
  
  // Función para cerrar el modal
  function closeModal() {
    sizeChartModal.style.display = 'none';
    document.body.style.overflow = 'auto'; // Restaurar scroll del body
  }
  
  // Cerrar modal al hacer click en la X
  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }
  
  // Cerrar modal al hacer click en el fondo (overlay)
  sizeChartModal.addEventListener('click', function(e) {
    if (e.target === sizeChartModal) {
      closeModal();
    }
  });
  
  // Cerrar modal con la tecla ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sizeChartModal.style.display === 'flex') {
      closeModal();
    }
  });
});